import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../auth/service';
import { switchMap } from 'rxjs/operators';
import { ConfigService } from '../../app-config.service';
import { randomUUID } from 'crypto';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    /**
     *
     * @param {AuthenticationService} _authenticationService
     */
    constructor(private _authenticationService: AuthenticationService, private configService: ConfigService) {}

    /**
     * Add auth header with jwt if user is logged in and request is to api url
     * @param request
     * @param next
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isApiUrl = request.url.startsWith(this.configService.getConfig.apiUrl);
        return this._authenticationService.isLoggedIn(false).pipe(
            switchMap((loggedIn) => {
                if (loggedIn) {
                    // SwitchMap to transform isLoggedIn() boolean observable to  Observable<HttpEvent<any>>
                    const currentUser = this._authenticationService.currentUserValue;
                    const isLoggedIn = currentUser && currentUser.token;
                    if (currentUser && isLoggedIn && isApiUrl) {
                        request = request.clone({
                            setHeaders: {
                                Authorization: `Bearer ${currentUser.token}`,
                            },
                        });
                    }
                }

                return next.handle(request);
            }),
        );
    }
}
